import * as Yup from 'yup';
import { telephoneValidation, postcodeValidation } from 'utils/form/validation';
import { nullableString } from 'utils/form/validation';
import { FIELDS } from '../types';

const errorMessage = {
  required: 'This field is required.',
};

const addressShape = {
  [FIELDS.POSTCODE]: postcodeValidation()
    .nullable()
    .required(errorMessage.required),
  [FIELDS.HOUSE_NUMBER]: nullableString().required(errorMessage.required),
  [FIELDS.ADDRESS_LINE_1]: nullableString(),
  [FIELDS.ADDRESS_LINE_2]: nullableString(),
  [FIELDS.CITY]: nullableString()
    .min(3, 'City field must have at least 3 characters.')
    .required(errorMessage.required),
  [FIELDS.COUNTY]: nullableString(),
};

const adminShape = Yup.object().shape({
  [FIELDS.ADMIN_EMAIL]: Yup.string()
    .email('Please provide correct email address.')
    .required(errorMessage.required),
  [FIELDS.ADMIN_PHONE]: telephoneValidation().required(errorMessage.required),
  [FIELDS.ADDRESS]: Yup.object().shape(addressShape),
});

export default Yup.object().shape({
  [FIELDS.EMAIL]: Yup.string()
    .email('Please provide correct email address.')
    .required(errorMessage.required),
  [FIELDS.PHONE]: telephoneValidation().required(errorMessage.required),
  [FIELDS.ADDRESS]: Yup.object().shape(addressShape),
  [FIELDS.ADMINS]: Yup.array().of(adminShape),
});
